import React from 'react';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextAlign,
    availableTextDecoration,
    availableLineHeight
} from '../../constants/availableFonts';

const cardStoreDefaults = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextDecoration: availableTextDecoration,
    availableLineHeight: availableLineHeight,
    availableTextAlign: availableTextAlign
};

const cardReducer = (state = cardStoreDefaults, action) => {
    return state;
};

export default cardReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/card.js